import { v4 as uuidv4 } from "uuid";
import * as types from "./actionTypes";
import * as templateApi from "../../api/templateApi";
import { updateTemplateProgressType } from "./templateProgressActions";
import { updateEntireFormConfig } from "./formConfigActions";
import { setFormTitle, updateEntireForms } from "./formActions";
import { seralizeTemplateData } from "./utils";
import { defaultTemplates } from "../../components/ChooseTemplate/defaultTemplates.json";
import { resetState } from "./resetActions";

export function loadingTemplates() {
  return { type: types.LOADING_TEMPLATES };
}
export function loadingTemplatesSuccess(templates) {
  return { type: types.LOAD_TEMPLATES_SUCCESS, templates };
}
export function getTemplateSuccess(template) {
  return { type: types.GET_TEMPLATE_SUCCESS, template };
}
export function deleteTemplateSuccess(templateId) {
  return { type: types.DELETE_TEMPLATE_SUCCESS, templateId };
}
export function saveTemplateSuccess(template) {
  return { type: types.SAVE_TEMPLATE_SUCCESS, template };
}
export function updateTemplateSuccess(template) {
  return { type: types.UPDATE_TEMPLATE_SUCCESS, template };
}

export function apiTemplateError(error) {
  return { type: types.API_TEMPLATE_ERROR, error };
}

export function getTemplates() {
  return function (dispatch) {
    dispatch(loadingTemplates());
    return templateApi
      .getTemplates()
      .then((templates) => {
        dispatch(loadingTemplatesSuccess(templates));
      })
      .catch((error) => {
        dispatch(apiTemplateError(error.response));
        throw error;
      });
  };
}

export function getTemplate(templateId, templateType = "custom") {
  return function (dispatch) {
    dispatch(loadingTemplates());
    return templateApi
      .getTemplate(templateId)
      .then((template) => {
        dispatch(getTemplateSuccess(template));
        dispatch(updateTemplateProgressType(template.progressType));
        dispatch(updateEntireFormConfig(template.form.submissionConfig));
        dispatch(updateEntireForms(template.form));
      })
      .catch((error) => {
        if (templateType == "default") {
          const template = defaultTemplates.find(
            (template) => templateId == template.id
          );
          template.id=uuidv4();
          return dispatch(createTemplate(template));
        }
        dispatch(apiTemplateError(error.response));
        throw error;
      });
  };
}
export function createTemplate(template) {
  return function (dispatch) {
    dispatch(loadingTemplates());
    return templateApi
      .createTemplate(template)
      .then((template) => {
        dispatch(saveTemplateSuccess(template));
        if (template.templateType == "default") {
          dispatch(updateTemplateProgressType(template.progressType));
          dispatch(updateEntireFormConfig(template.form.submissionConfig));
          dispatch(updateEntireForms(template.form));
        }
        dispatch(setFormTitle(template.title));
      })
      .catch((error) => {
        dispatch(apiTemplateError(error.response));
        throw error;
      });
  };
}
export function updateTemplate() {
  return function (dispatch, getState) {
    const state = getState();
    const { id: templateId } = state.templates.currentTemplate;
    const updateData = seralizeTemplateData(state);
    if (updateData.form.title != "Add a form title") {
      updateData.title = updateData.form.title;
    }
    dispatch(loadingTemplates());
    return templateApi
      .updateTemplate(templateId, updateData)
      .then((template) => {
        dispatch(updateTemplateSuccess(template));
        dispatch(resetState());
      })
      .catch((error) => {
        dispatch(apiTemplateError(error.response));
        throw error;
      });
  };
}
export function deleteTemplate(templateId) {
  return function (dispatch, getState) {
    dispatch(loadingTemplates());
    return templateApi
      .deleteTemplate(templateId)
      .then((response) => {
        dispatch(deleteTemplateSuccess(templateId));
      })
      .catch((error) => {
        dispatch(apiTemplateError(error.response));
        throw error;
      });
  };
}
export function deleteTemplates(templateIds) {
  return function (dispatch, getState) {
    dispatch(loadingTemplates());
    return templateApi
      .deleteTemplates(templateIds)
      .then((response) => {
        dispatch(deleteTemplateSuccess(templateIds));
      })
      .catch((error) => {
        dispatch(apiTemplateError(error.response));
        throw error;
      });
  };
}
// export function updateTemplate(templateId, data) {
// 	return { type: types.UPDATE_TEMPLATE_SUCCESS, template: data };
// }
